import React from 'react'
import { Button, Stack } from '@mui/material'
import { useAiAssistantOptional } from './AiAssistantContext'
import type { TrackerAction } from './trackerActions'

type Props = {
    actions: TrackerAction[]
}

/** Modify / Cancel shortcuts on a live order; they route through chat so a proposal card is still confirmed. */
export default function OrderTrackerActions({ actions }: Props) {
    const assistant = useAiAssistantOptional()
    if (!assistant || actions.length === 0) return null
    const { onSend, setInput, loading } = assistant
    return (
        <Stack direction="row" spacing={0.5} justifyContent="flex-end" flexWrap="wrap" sx={{ mt: 0.75 }}>
            {actions.map((action) => (
                <Button
                    key={action.key}
                    size="small"
                    variant="text"
                    color={action.kind === 'cancel' ? 'error' : 'primary'}
                    disabled={loading}
                    onClick={() => (action.send ? onSend(action.prompt) : setInput(action.prompt))}
                    sx={{ minWidth: 0, px: 1, py: 0.25, fontSize: '0.75rem', textTransform: 'none' }}
                >
                    {action.label}
                </Button>
            ))}
        </Stack>
    )
}
